
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#363840"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.4 19.6V13h-.8v6.6H13v.8h6.6V27h.8v-6.6H27v-.8h-6.6z","fill":"#fff"}})])
      }
    
      }
    